module.exports = __webpack_public_path__ + "static/phigora-macbook@2x-150x150-374f3ff6536eed36eef41b90ac579b22.png";